import type { FaireProductEntity } from "../../entity_types/product";

export const p_mzzckmkk2m: FaireProductEntity = {
  token: "p_mzzckmkk2m",
  type: "product",
  name: '(DZ) WORRY STONES - COPPER (DZ) 1.5-1.75"',
  brandToken: "b_b1k03395mh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a2db9304a58583913e857e4611efa415d43700332bf5c0fa8bb094d055b55a21.jpeg",
  galleryImageUrls: [],
  priceDollars: 47.7,
  description:
    'Explore tranquility with our Copper Worry Stones, offered by Oceanic Linkways Inc, a leader in spiritual wellness products since 1991. These 1.5-1.75" stones are a staple in spiritual practices. Made from pure copper, they embody our commitment to quality and serene living. Sourced from 19 countries, each stone represents our dedication to providing high-quality products.',
  tags: [],
  msrpDollars: 95.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:06.208Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
